
const SpinnerIcon = ({ className = "h-12 w-12" }: { className?: string }) => {
  return (
    <div className={`animate-spin rounded-full border-t-2 border-b-2 border-blue-500 ${className}`} />
  );
};

export default SpinnerIcon;
